module.exports = __webpack_public_path__ + "static/media/10.ee4ee645.mp3";